import { render, staticRenderFns } from "./RutaForm.vue?vue&type=template&id=68e3dcb2"
import script from "./RutaForm.vue?vue&type=script&lang=js"
export * from "./RutaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports